export const ORDER_WITHOUT_EMAIL_ID = 'OrderWithoutEmail';

export const DATADOG_CLIENT_TOKEN = 'pubbedf0e40f9257ddaafa5eca11676e63c';